export default "/react/vk_dzen-71d97390.svg";